import React from 'react';
import $ from 'jquery';

export default class DrawingCanvasUtil {

  static parseXml(xml) {
    if (window.DOMParser)
    {
      let parser = new DOMParser();
      return parser.parseFromString(xml, 'text/xml');
    }
    else
    {
      xml = xml.replace(/<!DOCTYPE svg[^>]*>/, '');
      let xmlDoc = new ActiveXObject('Microsoft.XMLDOM');
      xmlDoc.async = 'false';
      xmlDoc.loadXML(xml);
      return xmlDoc;
    }
  }

  static xmlToString(xml) {
    return new XMLSerializer().serializeToString(xml);
  }

  static makeEmptySVG(width, height) {
    return (this.parseXml(
      `<svg width="${width}"
            height="${height}"
            viewBox="0 0 ${width} ${height}"
            xmlns="http://www.w3.org/2000/svg"></svg>`
    ));
  }

  static encodeFullText(text) {
    const encode = text.replace(/\n/gi, '\\n');
    return encode;
  }

  static decodeFullText(text) {
    const decode = text.replace(/\\n/gi, '\n');
    return decode;
  }

  static applyTSpans(xml, textEl, linesInfo, style) {
    const x = parseInt(textEl.getAttribute("x"));
    const y = parseInt(textEl.getAttribute("y"));
    for (let [i, val] of linesInfo.lines.entries()) {
      let tspanEl = xml.createElement("tspan");
      if (val.length === 0) val = ' ';
      let textNode = xml.createTextNode(val);
      tspanEl.appendChild(textNode);
      tspanEl.setAttribute('x', x);
      tspanEl.setAttribute('dy', i === 0 ? 0 : '1em');
      tspanEl.setAttribute('dominant-baseline', 'alphabetic');
      tspanEl.setAttribute('style', 'baseline-shift: 0%;');
      tspanEl.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
      textEl.appendChild(tspanEl);
    }
  }

  static adjustTSpans(textNode) {
    const x = parseInt(textNode.getAttribute('x'));
    const tspans = textNode.childNodes;
    for (let i = 0; i < tspans.length; i++) {
      tspans[i].setAttribute('x', x);
    }
  }

  static packTextIntoLines(text) {
    const lineData = text.split('\n');
    return { lines: lineData };
  }

  static appendText(xml, text, x, y, width, height, style) {
    const linesInfo = this.packTextIntoLines(text);
    let svgRoot = xml.getElementsByTagName("svg")[0];
    let textEl = xml.createElement("text");
    textEl.setAttribute('x', x);
    textEl.setAttribute('y', y);
    textEl.setAttribute('font-family', style['font-family']);
    textEl.setAttribute('font-size',  style['font-size']);
    textEl.setAttribute('fill',  style['color']);
    textEl.setAttribute('font-weight',  style['font-weight']);
    textEl.setAttribute('font-style',  style['font-style']);
    textEl.setAttribute('text-decoration',  style['text-decoration']);
    textEl.setAttribute('full-text', this.encodeFullText(text));
    textEl.setAttribute('width', style['width']);
    textEl.setAttribute('height', style['height']);
    textEl.setAttribute('shape', 'false');
    this.applyTSpans(xml, textEl, linesInfo, style);
    svgRoot.appendChild(textEl);
    return textEl;
  }

  static removeElem(elem) {
    if (elem && elem.parentNode)
      elem.parentNode.removeChild(elem);
  }

  static appendTextArea(xml, text, x, y, style) {
    let svgRoot = xml.getElementsByTagName("svg")[0];

    let foreignObjectEl = document.createElement("foreignObject");
    foreignObjectEl.setAttribute('id', 'inputTextArea');
    foreignObjectEl.setAttribute('x', x);
    foreignObjectEl.setAttribute('y', y - 1);
    foreignObjectEl.setAttribute('width', '100%');
    foreignObjectEl.setAttribute('height', '100%');

    let divEl = document.createElement('div');
    divEl.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');

    let textAreaEl = document.createElement("textarea");
    if (style.id !== undefined) textAreaEl.setAttribute('ezdcid', style.id);
    textAreaEl.setAttribute('x', x);
    textAreaEl.setAttribute('y', y);
    textAreaEl.setAttribute('wrap', 'off');
    textAreaEl.setAttribute('style', `
      font-size: ${ style.textSize + 'px' };
      color: ${ style.textColor };
      font-weight: ${ style.fontWeight };
      font-style: ${ style.fontStyle };
      text-decoration: ${ style.textDecoration };
      font-family: ${ style.font };
    `);
    textAreaEl.setAttribute('placeholder', 'Type here...');
    textAreaEl.setAttribute('rows', 1);
    textAreaEl.setAttribute('data-min-rows', 1);

    if (text && text.length > 0) {
      if (text[0] === '\n') {
        text = '\n' + text;
      }
      let textNode = document.createTextNode(text);
      textAreaEl.appendChild(textNode);
    }

    divEl.appendChild(textAreaEl);
    foreignObjectEl.appendChild(divEl);
    svgRoot.appendChild(foreignObjectEl);
    return foreignObjectEl;
  }

  static replaceTextAreaWithText(xml, textAreaEl) {
    const textAreaRef = $('foreignObject textarea');
    let style = {
      'font-family': textAreaRef.css('font-family'),
      'font-size': textAreaRef.css('font-size'),
      'color':  textAreaRef.css('color'),
      'font-weight': textAreaRef.css('font-weight'),
      'font-style': textAreaRef.css('font-style'),
      'text-decoration': textAreaRef.css('text-decoration').split(' ')[0],
      'width': textAreaRef.css('width'),
      'height': textAreaRef.css('height'),
    };
    const fontSize = parseInt(textAreaRef.css('font-size'));
    const fontHeight =  fontSize - (fontSize - fontSize / 1.180952381);
    const padding = 5;
    let textEl = null;
    if (textAreaRef.val() !== '') {
      textEl = this.appendText(xml,
        textAreaRef.val(),
        parseInt(textAreaRef.attr('x'), 10) + padding + 1,
        parseInt(textAreaRef.attr('y'), 10) + padding + fontHeight,
        textAreaRef.width(),
        textAreaRef.height(),
        style
      );
      textEl.setAttribute('ezdcid', textAreaRef.attr('ezdcid'));
    }
    this.removeElem(textAreaEl);
    return textEl;
  }

  static getAllElements(xml) {
    if (xml === null) return [];
    let svgRoot = xml.getElementsByTagName("svg")[0];
    return svgRoot.childNodes;
  }

}
